import { Col, Dropdown, Row, Text } from 'components';
import { useTranslation } from 'react-i18next';

const statuses = [
  {
    value: 'All Statuses',
    opt: undefined
  },
  {
    value: "Today's games",
    subtitle: 'Shows games for all timezones.',
    opt: 'today'
  },
  {
    value: 'Scheduled',
    opt: 'scheduled'
  },
  {
    value: 'In Play',
    opt: 'in-play'
  },
  {
    value: 'Finished',
    opt: 'finished'
  },
  {
    value: 'Postponed',
    opt: 'postponed'
  },
  {
    value: 'Canceled',
    opt: 'canceled'
  },
  {
    value: 'Abandoned',
    opt: 'abandoned'
  },
  {
    value: 'Not Played',
    opt: 'not-played'
  }
];

const sports = [
  {
    value: 'All'
  },
  {
    value: `Soccer`,
    opt: 'soccer'
  },
  {
    value: 'Basketball',
    opt: 'basketball'
  },
  {
    value: 'Baseball',
    opt: 'baseball'
  },
  {
    value: 'American Football',
    opt: 'americanFootball'
  }
];

const Filters = ({ status, setStatus, sport, setSport }) => {
  const { t } = useTranslation();

  return (
    <Row start gap="30px" pad="12px 24px" noFlex>
      <Col noFlex>
        <Dropdown
          admin
          title="Filter by status"
          wid="300px"
          selected={status.value}
          options={statuses}
          handleSelect={setStatus}
          rounded
          small
        />

        {status.opt === 'today' && (
          <Text c1 med marg="2px 0 0 16px">
            * Shows games for all timezones.
          </Text>
        )}
      </Col>

      <Dropdown
        admin
        title="Filter by sport"
        wid="300px"
        selected={sport.value}
        options={sports}
        handleSelect={setSport}
        rounded
        small
      />
    </Row>
  );
};

export default Filters;
